import DxmlRun from "../DxmlRun"
import { useEditorFile } from "../../../../../hooks/useEditorFile";

export default function DxmlHyperlink({ editorHyperlink }) {
    const { getKeyById } = useEditorFile();

    return (
        <a href={editorHyperlink.Href}  target={editorHyperlink.Target}>
            {editorHyperlink.Items.map((editorRun) => (
                <DxmlRun key={getKeyById(editorRun)} editorRun={editorRun}/>
            ))}
        </a>
    )
}